import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';

export function* unlockRoomSaga() {
  yield call(SignalingSocket.send, {
    event: 'unlockRoom',
  });
}
